module.exports = __webpack_public_path__ + "fde858986ce3e8959de0f63ca18e680c.svg";